<div
  class="ui-annual-status-calendar"
  (mousemove)="moveTooltip($event)"
  (mouseleave)="hideTooltip()"
>
  <div class="ui-annual-status-calendar__viewport">
    <table class="ui-annual-status-calendar__table" [attr.aria-label]="ariaLabel()">
      <thead>
        <tr>
          <th scope="col" class="ui-annual-status-calendar__month-heading">Mes</th>
          @for (day of dayNumbers; track day) {
            <th
              scope="col"
              class="ui-annual-status-calendar__day-heading"
              [class.ui-annual-status-calendar__day-heading--active]="hoveredCell()?.day === day"
            >
              {{ day }}
            </th>
          }
          <th scope="col" class="ui-annual-status-calendar__total-heading">Total</th>
        </tr>
      </thead>
      <tbody>
        @for (month of months(); track month.index) {
          <tr>
            <th
              scope="row"
              class="ui-annual-status-calendar__month"
              [class.ui-annual-status-calendar__month--active]="hoveredCell()?.month === month.index"
            >
              {{ month.name }}
            </th>
            @for (day of dayNumbers; track day) {
              <td
                class="ui-annual-status-calendar__cell"
                [class.ui-annual-status-calendar__cell--row-active]="hoveredCell()?.month === month.index"
                [class.ui-annual-status-calendar__cell--column-active]="hoveredCell()?.day === day"
              >
                @if (day <= month.days) {
                  @let status = statusFor(month.index, day);
                  @let entry = entryFor(month.index, day);
                  <span
                    class="ui-annual-status-calendar__day"
                    [class.ui-annual-status-calendar__day--empty]="!status"
                    [class.ui-annual-status-calendar__day--clickable]="isCellClickable(entry)"
                    [class.ui-annual-status-calendar__day--active]="hoveredCell()?.month === month.index && hoveredCell()?.day === day"
                    [style.--ui-annual-status-color]="status?.color ?? null"
                    [style.--ui-annual-status-border]="status?.borderColor ?? status?.color ?? null"
                    [style.--ui-annual-status-text]="status?.textColor ?? null"
                    [attr.aria-label]="cellLabel(month, day)"
                    [attr.role]="isCellClickable(entry) ? 'button' : 'img'"
                    [attr.tabindex]="isCellClickable(entry) ? 0 : null"
                    (mouseenter)="showTooltip(month.index, day)"
                    (click)="onCellClick(entry, $event)"
                    (keydown)="onCellKeydown(entry, $event)"
                  >
                    @if (showQuantity() && entry?.quantity !== undefined) {
                      <span class="ui-annual-status-calendar__quantity">
                        {{ entry?.quantity }}
                      </span>
                    }
                  </span>
                }
              </td>
            }
            <td
              class="ui-annual-status-calendar__total"
              [class.ui-annual-status-calendar__total--active]="hoveredCell()?.month === month.index"
              [attr.aria-label]="'Total de ' + month.name + ': ' + monthTotals()[month.index]"
            >
              {{ monthTotals()[month.index] }}
            </td>
          </tr>
        }
      </tbody>
    </table>
  </div>

  @if (tooltip(); as currentTooltip) {
    <div
      class="ui-annual-status-calendar__tooltip"
      [style.left.px]="tooltipX()"
      [style.top.px]="tooltipY()"
      aria-hidden="true"
    >
      <span
        class="ui-annual-status-calendar__tooltip-dot"
        [style.background]="currentTooltip.status.color"
      ></span>
      <span class="ui-annual-status-calendar__tooltip-body">
        <span class="ui-annual-status-calendar__tooltip-title">
          {{ currentTooltip.status.label }}
        </span>
        <span>Fecha: {{ tooltipDate(currentTooltip.entry) }}</span>
        @if (currentTooltip.entry.tooltipDetails?.length) {
          @for (detail of currentTooltip.entry.tooltipDetails; track detail.label) {
            <span>{{ detail.label }}: {{ detail.value }}</span>
          }
        } @else {
          <span>Cantidad: {{ currentTooltip.entry.quantity ?? 0 }}</span>
        }
      </span>
    </div>
  }

  @if (statuses().length) {
    <div class="ui-annual-status-calendar__legend" aria-label="Leyenda de estados">
      @for (status of statuses(); track status.id) {
        <span class="ui-annual-status-calendar__legend-item">
          <span
            class="ui-annual-status-calendar__legend-swatch"
            [style.background]="status.color"
            [style.border-color]="status.borderColor ?? status.color"
            aria-hidden="true"
          ></span>
          {{ status.label }}
        </span>
      }
    </div>
  }
</div>
